module.exports = __webpack_public_path__ + "img/noData2.f0dce95a.png";